import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { StockSimulationService } from "src/app/services/stock-simulation.service";
import * as XLSX from "xlsx";

@Component({
  selector: "app-stock-simulation",
  templateUrl: "./stock-simulation.component.html",
  styleUrls: ["./stock-simulation.component.css"],
})
export class StockSimulationComponent implements OnInit {
  public userProfile = null;
  public customerCode: string;
  public email: string;
  public product: any;
  public items: any;
  public arrayProduct = [];
  public isFileUploaded = false;
  public isFileValid = true;
  public isFormatTrue = false;
  public remarks: string;
  public message: string;
  public filepath;
  public isLoading = false;

  constructor(
    private authService: AuthenticationService,
    private stockService: StockSimulationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.userProfile = this.authService.getObjUserProfile();
    this.customerCode = this.userProfile.customer_code;
    this.email = this.userProfile.email;
  }

  public download() {
    let link = document.createElement("a");
    link.setAttribute("type", "hidden");
    link.href = "assets/file/template-checking-stock.xlsx";
    link.download = "Template Checking Stock";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onFileSelected(files: FileList) {
    this.isFileUploaded = true;
    const file = files.item(0);

    if (!this.validateFile(file.name)) {
      this.isFileValid = false;
      this.isFormatTrue = false;
    } else if (this.validateFile(file.name)) {
      this.isFormatTrue = true;
      this.isFileValid = true;

      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = reader.result;
          const workBook: XLSX.WorkBook = XLSX.read(data, { type: "binary" });
          const workSheetsName: string = workBook.SheetNames[0];
          const workSheets: XLSX.WorkSheet = workBook.Sheets[workSheetsName];
          const jsonData = XLSX.utils.sheet_to_json(workSheets, { header: 1 });

          this.product = jsonData.slice(1);
        };
        reader.readAsBinaryString(file);
      }
    }
    this.changeDetectorRef.detectChanges();
    console.log(this.isFileValid);
  }

  public validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf(".") + 1);
    if (ext.toLowerCase() == "xlsx") {
      return true;
    } else {
      return false;
    }
  }

  public checkStock() {
    this.arrayProduct.splice(0, this.arrayProduct.length);
    this.isLoading = true;
    this.message = "";
    this.remarks = "";
    for (var i = 0; i < this.product.length; i++) {
      this.items = {
        product_id: this.product[i][1].toString(),
        product_desc: this.product[i][2],
      };

      this.arrayProduct.push(this.items);
    }

    const arrayObj = {
      customer_id: this.customerCode,
      email_recipients: this.email,
      items: this.arrayProduct,
    };

    this.stockService.postCheckStock(
      arrayObj,
      (response) => {
        console.log(response);
        this.isLoading = false;
        if (response.code == 400) {
          this.message = response.message;
        } else if (response.code == 200) {
          this.remarks = response.data.remarks;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
